import React, { useState } from 'react';
import { Delete, Edit } from '@mui/icons-material';
import {
  Stack,
  Divider,
  IconButton,
  ListItem,
  ListItemText,
} from '@mui/material';
import ModalDialog from 'src/components/Global/ModalDialog';

const EmploymentStatusTile = ({ onEdit, onDelete, isDisabled, employmentStatus }) => {
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <ListItem
        secondaryAction={
          <Stack direction="row">
            <IconButton
              edge="end"
              aria-label="edit"
              size="small"
              disabled={isDisabled}
              onClick={() => onEdit(employmentStatus.id)}
            >
              <Edit size="small" />
            </IconButton>
            <IconButton
              edge="end"
              aria-label="delete"
              size="small"
              disabled={isDisabled}
              onClick={handleOpenModal}
            >
              <Delete size="small" />
            </IconButton>
          </Stack>
        }
      >
        <ListItemText
          primary={employmentStatus.status}
          sx={{ color: isDisabled ? '#d3d3d3' : undefined }}
        />
        <ModalDialog
          title="Delete Employment Status?"
          subTitle={`Are you sure do you want to delete this employment status? `}
          hardWarning={`This will affect all associated jobs to be not visible on the website.`}
          item={employmentStatus.status}
          open={openModal}
          handleClose={handleCloseModal}
          handleClickOk={() => {
            handleCloseModal();
            onDelete(employmentStatus.id);
          }}
        />
      </ListItem>

      <Divider />
    </>
  );
};

export default EmploymentStatusTile;